<template>
  <div>
    <app-input-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ClaimLimitSetup from "../../../components/claim/claimlimitsetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-input-form": ClaimLimitSetup,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupclaimlimit.createnewclaimlimitsetup'),
      pageTitleValue: "",
      formData: {
        clmtypeid: null,
        clmtypedesc: null,
      //  clmtypecat: null,
        startdate: null,
        enddate: null,
        prorate: false,
        claimlimitdetail: [],
        travellinglimitdetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      if (this.formData.prorate == false || this.formData.prorate == null) {
        this.formData.prorate = 0;
      } else {
        this.formData.prorate = 1;
      }

      this.$store.dispatch('post', {url: "/claimlimit/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "claimlimitsetuplist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "claimlimitsetuplist" });
    },
  },
};
</script>